import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Redirect } from 'react-router-dom';
import TabbedLayoutStyles from '../../components/TabbedLayoutStyles';
import NoItemsPage from '../../components/NoItemsPage';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { getPaymentMethod, getTokenField } from '../../token';
import { Invoices } from './Invoices';

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

class Account extends React.Component {
  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes } = this.props;
    const { value } = this.state;
    const subscriptionType = getTokenField('subscription_type');
    const subscriptionActive = subscriptionType === 'stripe_based_started';
    const paymentMethod = getPaymentMethod();
    const isProperPaymentMethod = paymentMethod === 'stripe';
    const redirect = !isProperPaymentMethod;
    return redirect ? (
      <Redirect to="/websites"/>
    ) : (
      <div className={classes.container}>
        <Tabs value={value} onChange={this.handleChange}>
          <Tab label="Invoices"/>
        </Tabs>
        {value === 0 && (
          <TabContainer>
            {subscriptionActive ? <Invoices/> : <NoItemsPage
              buttonText="START SUBSCRIPTION"
              href="#/subscription"
              title="You don’t have a subscription yet"
              subtitle="Start a subscription to see account details"
            />}
          </TabContainer>
        )}
      </div>
    );
  }
}

export const AccountPage = withStyles(TabbedLayoutStyles)(Account);
